import { DynamicComponentExitReason } from '@jack-henry/frontend-utils/lit/dynamic-component-registry';
import { TmDialogButtonPosture, TmDialogService } from '@treasury/presentation/services/dialog';
import { html } from 'lit';

export function showOverrides(dialogService: TmDialogService) {
    return dialogService.open<void>(
        html`<feature-flag-overrides></feature-flag-overrides>`,
        'Feature Flag Overrides',
        {
            buttons: [
                {
                    reason: DynamicComponentExitReason.Confirm,
                    posture: TmDialogButtonPosture.Primary,
                    label: 'Close',
                },
            ],
        }
    );
}
